import { createFileRoute } from '@tanstack/react-router';
import { PublishPage } from '../../../features/studio/pages/publish.tsx';

export const Route = createFileRoute('/_app/studio/bundles/$bundleId/versions/$version/publish')({
  component: PublishRoute,
});

function PublishRoute() {
  const { bundleId, version } = Route.useParams();
  return <PublishPage bundleId={bundleId} version={version} />;
}
